import * as React from 'react';
import { useTranslation } from 'react-i18next';

declare const $: any;

const MenuItem = ({ icon, command, disabled = false }: { icon: string; command: string; disabled?: boolean }) => {
    const { t } = useTranslation();
    return (
        <div className={ `${disabled ? 'disabled' : ''} item` } data-command={ command }>
            <i className={ `${icon} icon` }></i>
            <span>{ t(`COMMAND.${command}`) }</span>
        </div>
    );
};

const Divider = () =>
    <div className="divider"></div>
;

export type Props = {
    canDownload: boolean;
    canCopy: boolean;
    canPublish: boolean;
    canDelete: boolean;
    canEdit: boolean;
    canSchedule: boolean;
    onClickEdit(): void;
    onClickPublish(): void;
    onClickDownload(): void;
    onClickSchedule(): void;
    onClickExport(): void;
    onClickCopy(): void;
    onClickDelete(): void;
};

export class ThemeMenu extends React.Component<any, any> {
    element?: HTMLElement | null;

    componentDidMount() {
        if (this.element) {
            $(this.element).dropdown({
                onChange: (value: string, text: string, $element: any) => this.onChange($element.data('command')),
            });
        }
    }

    setRef = (e: HTMLDivElement) => {
        this.element = e;
    };

    onChange(command: string) {
        switch (command) {
            case "EDIT": return this.props.onClickEdit();
            case "DOWNLOAD": return this.props.onClickDownload();
            case "PUBLISH": return this.props.onClickPublish();
            case "EXPORT": return this.props.onClickExport();
            case "SCHEDULE": return this.props.onClickSchedule();
            case "COPY_": return this.props.onClickCopy();
            case "DELETE": return this.props.onClickDelete();
        }
        throw new Error('Unhandled ThemeMenu command: ' + command);
    }

    render() {
        const { canDownload, canPublish, canEdit, canSchedule, canCopy, canDelete, canExport } = this.props;
        return (
            <div className="ui floating tiny icon dropdown basic button" ref={ this.setRef }>
                <i className="setting icon"></i>
                <div className="menu">
                    { canEdit &&
                        <>
                            <MenuItem icon="edit" command="EDIT"/>
                            <Divider/>
                        </>
                    }
                    { canDownload && <MenuItem icon="cloud download" command="DOWNLOAD"/> }
                    { canPublish && <MenuItem icon="cloud upload" command="PUBLISH" /> }
                    { canExport && <MenuItem icon="cloud download" command="EXPORT" /> }
                    { canSchedule &&
                        <MenuItem icon="calendar" command="SCHEDULE" />
                    }
                    { canCopy &&
                        <>
                            <Divider/>
                            <MenuItem icon="copy" command="COPY_"/>
                        </>
                    }
                    { canDelete &&
                        <>
                            <Divider/>
                            <MenuItem icon="remove" command="DELETE"/>
                        </>
                    }
                </div>
            </div>
        );
    }
}
